import React from 'react'
import cx from 'classnames'

import LocationLevel from '@/modules/locationLevel.js'
import { SquiggleGroup } from '@/svgs.js'
import Newsletter from '@/modules/newsletter.js'

class LocationsBlock extends React.Component {
  constructor () {
    super()
    this.state = {
      active: 0
    }
  }
  render () {
    const {
      comingSoon,
      locations
    } = this.props
    const {
      hours,
      cardTitle,
      cardDescription,
      locationModules,
      subTitle,
      title,
      address,
    } = locations[0]
    return (
      <div className='locations__block container--xl ma p15 pmy'>
        <div className='x ac'>
          <h5 className='caps medium small'>Locations</h5>
          <div className={cx('locations__block-toggle rel f jcb aic', {
            'left-active': this.state.active === 0,
            'right-active': this.state.active === 1
          })}>
            <span onClick={() => this.setState({ active: 0 })} className={cx('p1 rel z1 s18 inline-block', {
              'is-active': this.state.active === 0
            })}>San Francisco</span>
            <span onClick={() => this.setState({ active: 1 })} className={cx('p1 rel z1 s18 inline-block', {
              'is-active': this.state.active === 1
            })}>Coming Soon</span>
          </div>
        </div>
        <div className={cx('locations__block-coming p15 container--l mxa pmy f fw jcb aic', {
          'is-active': this.state.active === 1
        })}>
          {comingSoon.map(soon => (
            <div className='ac locations__block-soon x rel' key={soon._key}>
              <div className='locations__block-flag bcw abs f jcc aic'>
                <span className='caps medium'>{soon.flag}</span>
              </div>
              <h2 className='mb0 pb1' dangerouslySetInnerHTML={{ __html: soon.title.replace(/[\r\n]+/g, '<br />') }} />
            </div>
          ))}
          <div className='x ac'>
            <h3 className='mb05'>Get notified when we launch!</h3>
            <div className='container--s mxa'>
              <Newsletter placeholder={`Enter your email`} />
            </div>
          </div>
        </div>
        <div className={cx('locations__block-active', {
          'is-active': this.state.active === 0
        })}>
          <div className='x f jcb aic fw pmy py15 locations__block-flex'>
            <div className='shadow__box locations__card bcw p1'>
              <h4 className='m0  pb1' dangerouslySetInnerHTML={{ __html: cardTitle.replace(/[\r\n]+/g, '<br />') }} />
              <p>{cardDescription}</p>
            </div>
            <div className='locations__block-name mt15 pt15 x f jcb'>
              <div>
                <h5 className='caps medium mb1'>{subTitle}</h5>
                <h2 className='m0 p0 squiggle__block inline-block'>
                  <span className='rel'>
                    {address}
                    <SquiggleGroup />
                  </span>
                </h2>
                <div>
                  <h2 className='m0 p0 squiggle__block inline-block'>
                    <span className='rel'>
                      {title}
                      <SquiggleGroup />
                    </span>
                  </h2>
                </div>
              </div>
              <div>
                <h5 className='caps medium mb0 pb0'>Hours</h5>
                <p className='mb0 s22 pb1' dangerouslySetInnerHTML={{ __html: hours.replace(/[\r\n]+/g, '<br />') }} />
              </div>
            </div>
          </div>
          <div>
            {locationModules[0].locationLevels.map((level, i) => (
              <div key={level._key}>
                <LocationLevel {...level} level={i} />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default LocationsBlock
